import { preventDefault } from "@/helpers/utils"
import { useTranslation } from "@/hooks/useTranslation"
import { DisconnectOutlined } from "@/icons"
import { ActionsDropdown } from "@/molecules/ActionsDropdown"

export const ActionRowMenu = ({ onRemove }: { onRemove: () => void }) => {
  const { t } = useTranslation()

  return (
    <ActionsDropdown
      menu={{
        items: [
          {
            key: "remove",
            icon: <DisconnectOutlined />,
            label: t("general.remove")
          }
        ],
        onClick: ({ key, domEvent }) => {
          if (key !== "remove") return
          preventDefault(domEvent)
          onRemove()
        }
      }}
    />
  )
}
